import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json";

// Client-side only index for the "Actions" pseudo-category in Global Search - no
// API call, same pattern as settingsSearchIndex.js. Each entry is a command-style
// shortcut: typing a matching keyword surfaces a direct action card instead of (or
// alongside) a record, so a plain User typing "apply leave" lands on the right page
// without having to know it's filed under "My Leave".
//
// "Change Password" can't deep-link straight to the modal - UserProfile.js opens it
// via local `showModal()` component state, not a route, and GlobalSearch lives in a
// different part of the tree. Navigating to /my-profile (where Change Password is
// reachable from the page itself) is the pragmatic choice here rather than wiring a
// cross-component modal trigger for one menu item.
//
// "Punch" / clock in-out has no dedicated route to send someone to - punching only
// happens via the header's <PunchButton /> (see containers/Topbar/index.js) - so no
// action entry is added for it rather than inventing a fake destination.
export const ACTIONS_SEARCH_INDEX = [
  {
    id: "apply-leave",
    label: "Apply for Leave",
    keywords: ["leave", "apply leave", "request leave", "apply for leave"],
    // NOT /user-leave-approve - that's the Reporting Manager/ARM TEAM approval
    // page (sets reporting_manager_id/assistant_reporting_manager_id from the
    // viewer), not a personal apply-leave page. /leave-application
    // (LeaveApplication.js) is the real self-scoped one, confirmed no
    // employee picker or manager-id logic.
    route: "/leave-application",
    resource: config.RESOURCES.LEAVE,
  },
  {
    id: "book-meeting-room",
    label: "Book a Meeting Room",
    keywords: ["book", "meeting", "room", "book meeting room", "book room"],
    route: "/book-meeting-room",
    resource: null,
  },
  {
    id: "change-password",
    label: "Change Password",
    keywords: ["password", "change password"],
    route: "/my-profile",
    resource: null,
  },
];

export const searchActionsIndex = (query) => {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return ACTIONS_SEARCH_INDEX.filter(
    (entry) =>
      entry.keywords.some((keyword) => keyword.includes(q) || q.includes(keyword)) &&
      (!entry.resource || getResource(entry.resource, ["read"]))
  );
};
